import AddCompanyModal from './AddCompanyModal';
import CompanySummaryModal from './CompanySummaryModal';

export default {
  AddCompanyModal,
  CompanySummaryModal,
};
